import { AuthService } from './../../../../core/auth.service';
import { HolidaysService } from '../../../../shared/services/holidays.service';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { CalendarServiceService } from '../../../../admin-panel/settings/time-restrictions/calendar-service.service';
import { PermissionsService } from '../../../../core/permissions.service';
import * as moment from 'moment';

@Component({
  selector: 'app-date-selector',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
})
export class DateSelectorComponent {
  calendarSettings: any;
  today: Date = new Date();

  @ViewChild('calendar') calendar: any;

  archivePermission: Date = new Date(
    moment().subtract(1, 'months').format('llll')
  );

  @Input() selectedDate: Date;
  @Input() labelToDisplay: string;
  @Input() stepMinute: number = 1;
  @Input() maxDate = moment().toDate();
  @Output() selectedDateChange = new EventEmitter<Date>();

  constructor(
    private calendarService: CalendarServiceService,
    private permissionsService: PermissionsService,
    private holidaysService: HolidaysService,
    private authService: AuthService
  ) {
    this.calendarSettings = this.calendarService.getSchema();
    this.archivePermission = this.getMinDate();
    this.permissionsService.setArchivePermission.pipe(
      tap((res) => {
        this.archivePermission = new Date(<any>res._body);
      }),
      catchError(() => {
        this.archivePermission = new Date(
          moment().subtract(1, 'months').format('llll')
        );
        return of();
      })
    );
  }

  applyClass(): void {
    setTimeout(() => {
      const datePicker = document.getElementsByClassName(
        'ui-datepicker-group'
      )[0];
      if (datePicker)
        Array.from(datePicker.getElementsByClassName('holiday-date')).forEach(
          (element: Element) => {
            element.parentElement.classList.add('holiday');
          }
        );
    });
  }

  dateChange() {
    this.selectedDateChange.emit(this.selectedDate);
  }

  openCalendar(event) {
    this.calendar.showOverlay(this.calendar.inputfieldViewChild.nativeElement);
    event.stopPropagation();
  }

  getMinDate() {
    return new Date(moment('2023-10-01').startOf('day').format('llll'));
  }

  checkDateForHoliday(date: any) {
    const calendarDate = new Date(date.year, date.month, date.day);
    calendarDate.setHours(0, 0, 0, 0);
    return this.holidaysService.isHoliday(calendarDate);
  }
}
